import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import OnboardCheckboxAgreement from "../base/onboard-checkbox-agreement-component/OnboardCheckboxAgreement";

const EndUseAgreementTTNETCheckbox = (props) => {
    const {t, i18n} = useTranslation();
    const {
        value,
        error,
        onChange,
        milesApproveValue,
        milesApproveError,
        milesApproveOnChange,
        showMilesApprove,
        hiddenMilesAndSmiles
    } = props;

    const [mValue, setMValue] = useState(value != null ? value : false);
    const [mError, setMError] = useState(error);

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        setMValue(value);
    }, [value])

    const handleChange = (val) => {
        if (error !== undefined) {
            setMError(null);
        }
        setMValue(val);
        if (onChange !== undefined)
            onChange(val);
    }

    const [mAutoAcceptValue, setMAutoAcceptValue] = useState(milesApproveValue != null ? milesApproveValue : false);
    const [mAutoAcceptError, setMAutoAcceptError] = useState(milesApproveError);

    useEffect(() => {
        setMAutoAcceptError(milesApproveError);
    }, [milesApproveError]);

    const handleAutoAcceptChange = (val) => {
        if (milesApproveError !== undefined) {
            setMAutoAcceptError(null);
        }
        setMAutoAcceptValue(val);
        if (milesApproveOnChange !== undefined)
            milesApproveOnChange(val);
    }

    const checkboxLabel = {
        label: t('login.ttnet_contract_approval'),
        link: [
            {
                text: t('login.ttnet_contract_approval_link'),
                agreement: {
                    confirm: true,
                    title: t('usage_aggreement.title'),
                    description: t('contracts.ttnet_end_user_agreement')
                }
            },
        ]
    }
    const checkboxDescription = {
        label: t('login.processing_of_personal_data'),
        link: [
            {
                text: t('login.processing_of_personal_data_link'),
                agreement: {
                    confirm: false,
                    title: t('usage_aggreement.title_ttnet'),
                    description: t('contracts.ttnet_information_text')
                }
            }
            // ,{
            //     text: t('login.processing_of_personal_data_link_2'),
            //     link: /tr/.test(i18n.language.toLowerCase()) ? "https://www.turkishairlines.com/tr-tr/miles-and-smiles/kurallar-ve-kosullar/miles-smiles-programi-veri-koruma-aydinlatma-metni" :
            //         "https://www.turkishairlines.com/en-tr/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html"
            // }
        ]
    }

    const checkboxDescriptionNotMilesAndSmiles = {
        label: t('login.processing_of_personal_data_not_miles'),
        link: [
            {
                text: t('login.processing_of_personal_data_link'),
                agreement: {
                    confirm: false,
                    title: t('usage_aggreement.title_ttnet'),
                    description: t('contracts.ttnet_information_text')
                }
            }
        ]
    }

    return (
        <div>

            {showMilesApprove && (
                <div>
                    <OnboardCheckboxAgreement
                        value={mAutoAcceptValue}
                        error={mAutoAcceptError}
                        onChange={(e) => handleAutoAcceptChange(e)}
                        label={{label: t('login.miles_and_smiles_auto_accept')}}/>
                    <div className="h-16"/>
                </div>
            )}

            <OnboardCheckboxAgreement
                value={mValue}
                error={mError}
                onChange={(e) => handleChange(e)}
                label={checkboxLabel}
                description={hiddenMilesAndSmiles ? checkboxDescriptionNotMilesAndSmiles : checkboxDescription}/>
        </div>

    )
};

export default EndUseAgreementTTNETCheckbox;
